
const ALL = 'ALL'
const LOW_STOCK = 'LOW_STOCK'
const LESS_THEN_180 = 'LESS_THAN_180'
const STOCKABLE_ALL = 'all'
const STOCKABLE = 'stockable'
const NON_STOCKABLE = 'non-stockable'

const STOCKABLE_VALUES_ARRAY = [STOCKABLE, NON_STOCKABLE];

const enumStockable = {
    [STOCKABLE]: 'Stockable',
    [NON_STOCKABLE]: 'Non-Stockable'
}; 

const enumInventoryStatuses = {
    [ALL]: 'All',
    [LOW_STOCK]: 'Low Stock Alerts',
    [LESS_THEN_180]: '<180d inventory',
}

exports.ALL = ALL;
exports.LOW_STOCK = LOW_STOCK;
exports.LESS_THEN_180 = LESS_THEN_180;
exports.enumInventoryStatuses = enumInventoryStatuses;
exports.STOCKABLE_ALL = STOCKABLE_ALL;
exports.STOCKABLE = STOCKABLE;
exports.NON_STOCKABLE = NON_STOCKABLE;
exports.STOCKABLE_VALUES_ARRAY = STOCKABLE_VALUES_ARRAY;
exports.enumStockable = enumStockable;